var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconJapanMap(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon_japan_map_svg__clip0_60074_19631)",
    fill: "#80A030"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.121 15.625v1.25h.938v-.625h.625v3.125H4.87V15h-3.75v.625zM9.246 16.563H6.121v1.875h3.125v-1.875z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.871 10l-4.062 3.75H6.12l-.625.625v1.563h5V17.5h1.25v-1.25h1.875l1.875-1.875h1.25v1.25h.625V7.187h-2.5V10zM18.621 3.125l-2.5-2.5h-.625v3.75h-.625v1.563h1.25V5h3.75V3.125h-1.25z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon_japan_map_svg__clip0_60074_19631"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.496)",
    d: "M0 0h20v20H0z"
  })))));
}

export default SvgIconJapanMap;